import type { Project } from '@/api/client';
import type { ProjectFilesTypeFilterPersistence } from '@/components/ProjectFilesPopover/projectFilesPopoverTypeFilterModel';

/** Выбор файлов, чьи ссылки попадут в письмо (галочки в списке). */
export interface ProjectFileLinkSelectionProps {
  selectedIds: ReadonlySet<string>;
  onToggle: (fileId: string, nextSelected: boolean) => void;
}

/** Один файл в черновике до создания проекта (тип задаётся до загрузки). */
export interface ProjectFileDraftItem {
  file: File;
  file_type?: string | null;
  /** Локальный расчёт до отправки на сервер (PDF/DOCX) */
  file_author_sheets?: number | null;
  file_pages?: number | null;
  /** PDF/DOCX: расчёт не удался — в мете N/A для АЛ и СТР */
  file_metrics_unavailable?: boolean;
}

/** Черновик файлов до создания проекта (локальное состояние). */
export interface ProjectFilesLocalDraft {
  files: ProjectFileDraftItem[];
  onFilesChange: (files: ProjectFileDraftItem[]) => void;
  titleName: string;
  /**
   * После выбора типа «Текст» для строки черновика (метрики уже на `ProjectFileDraftItem`, если файл PDF/DOCX).
   * Например, синхронизация полей проекта «Страницы» / «Авторские листы» в модалке создания проекта.
   */
  onDraftFileMarkedText?: (item: ProjectFileDraftItem) => void;
}

/** Существующий проект: список с сервера, опционально режим выбора ссылок для письма. */
export type ProjectFilesPopoverServerProps = {
  open: boolean;
  onClose: () => void;
  project: Project;
  anchorEl: HTMLElement | null;
  fileLinkSelection?: ProjectFileLinkSelectionProps;
  typeFilterPersistence?: ProjectFilesTypeFilterPersistence;
};

export type ProjectFilesPopoverLocalDraftProps = {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  localDraft: ProjectFilesLocalDraft;
};

export type ProjectFilesPopoverProps = ProjectFilesPopoverServerProps | ProjectFilesPopoverLocalDraftProps;

export function isLocalDraftFilesProps(p: ProjectFilesPopoverProps): p is ProjectFilesPopoverLocalDraftProps {
  return 'localDraft' in p && p.localDraft != null;
}
